import socialAgentImg from '@/assets/images/theme-social-agent-v2.jpg';
import modernAgentImg from '@/assets/images/theme-modern-agent-v2.jpg';
import savvyAgentImg from '@/assets/images/theme-savvy-agent-v2.jpg';

export default [
        {
          id: 1,
          name: "The Social Agent",
          subtitle: "Theme 1",
          thumbnail: socialAgentImg,
          region: "USA"
        },
        {
          id: 2,
          name: "The Modern Agent",
          subtitle: "Theme 2",
          thumbnail: modernAgentImg,
          region: "USA" 
        },
        {
          id: 3,
          name: "The Savvy Agent",
          subtitle: "Theme 3",
          thumbnail: savvyAgentImg,
          region: "USA"
        },
        {
          id: 4,
          name: "The Social Agent",
          subtitle: "Theme 1",
          thumbnail: socialAgentImg,
          region: "Canada"
        },
        {
          id: 5,
          name: "The Modern Agent",
          subtitle: "Theme 2",
          thumbnail: modernAgentImg,
          region: "Canada"
        },
        {
          id: 6,
          name: "The Savvy Agent",
          subtitle: "Theme 3",
          thumbnail: savvyAgentImg,
          region: "Canada"
        }
];
  